import axios from "axios";

export default class DownloadApi {

    constructor(api) {
        this.api = api;
    }

    download(link, name) {
        axios.get(link, {responseType: 'blob'})
            .then(response => {
                const blob = new Blob([response.data], {type: 'application/pdf'})
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = name;
                link.click()
                URL.revokeObjectURL(link.href)
            })
    }
}
